import { useMsal } from '@azure/msal-react';
import { useContext, useMemo } from 'react';
import { AuthContext } from './AuthContext';
/**
 * Return authentication context
 */
export const useAuth = () => {
    const auth = useContext(AuthContext);
    if (!auth)
        throw Error('useAuth hook must be used under AuthProvider');
    // if we are using MSAL, use value from here
    const { inProgress } = useMsal();
    // if we are using a different auth, add its hook to get its context here
    // IE: const {inProgress} = useAdal();
    // and then we can decide which one to use based on auth.authType
    // IE: const inProgress = auth.authType === AuthType.MSAL ? use value from msalContext else use value from adalContext
    // return augmented auth context
    return useMemo(() => ({
        inProgress,
        auth
    }), [auth, inProgress]);
};
//# sourceMappingURL=useAuth.js.map